import axiosInstance from "./AxiosInstance";


export function getDepartments( pagination, pageid,search_by = "", search_keyword = "", sort_by = "",sort_order = "") {
  return axiosInstance.post(
    '/admin/DepartmentList',
    {  pagination, pageid ,search_by, search_keyword, sort_by, sort_order}
  );
}

export function createDepartment(departmentData) {
  return axiosInstance.post("/admin/addDepartment",departmentData);
}

export function updateDepartment(departmentData) {
  return axiosInstance.post(`/admin/editDepartment`, departmentData);
}

export function deleteDepartment(department) {
  return axiosInstance.post(`/admin/deleteDepartment`, department);
}

export function formatDepartments(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map(department => ({
      ...department,
      department_id: department.department_id || department._id || department.id

    }));
  }

  let departments = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      departments.push({
        ...responseData[key],
        department_id: responseData[key].department_id || responseData[key]._id || responseData[key].id || key,
      });
    }
  }
  return departments;
}
